import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SCROLL_THRESHOLD = 300;

/**
 * Nút nổi "Lên đầu trang", chỉ hiện khi đã cuộn quá SCROLL_THRESHOLD.
 * Đặt cố định theo viewport nên dùng được ở bất kỳ trang nào trong AppShell.
 */
export function ScrollToTopButton(): JSX.Element {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: SCROLL_THRESHOLD });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={trigger}>
      <Fab
        color="primary"
        size="medium"
        aria-label="Lên đầu trang"
        onClick={scrollToTop}
        sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: (theme) => theme.zIndex.tooltip }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
}
